import { ActionIcon } from "@mantine/core";
import type { ReactNode } from "react";

import { useNavbarCollapse } from "@/hooks/navbar";

import { ChevronLeftIcon, ChevronRightIcon } from "../icon";
import classes from "./_css/index.module.css";

type Props = {
  children: ReactNode;
};

export function Navbar({ children }: Props) {
  const { isCollapsed, toggleCollapse } = useNavbarCollapse();
  return (
    <nav
      className={`${classes.navbar} ${isCollapsed ? classes.collapsed : ""}`}
    >
      <ActionIcon
        className={`${classes.collapseButton} ${
          isCollapsed ? classes.collapsed : ""
        }`}
        onClick={toggleCollapse}
        aria-label={isCollapsed ? "展開" : "折りたたむ"}
        radius="lg"
        size="lg"
        variant="outline"
      >
        {isCollapsed ? (
          <ChevronRightIcon width={20} />
        ) : (
          <ChevronLeftIcon width={20} />
        )}
      </ActionIcon>
      {children}
    </nav>
  );
}
